import React from 'react';

/**
 * Joined rounded rectangle: colored left half + light right half.
 * @param {'score' | 'rank' | 'meta' | 'warning'} [variant]
 */
export default function JupasSplitPill({
  left,
  right,
  leftColor = '#185FA5',
  leftTextClass = 'text-white',
  variant = 'score',
  title,
  className = '',
}) {
  // Score/warning: grade column is content-sized (longest DSE grade is "5**").
  // Rank/meta keep fixed split ratios.
  const useMinimalGrade = variant === 'score' || variant === 'warning';
  const leftRatio =
    variant === 'rank' ? 'w-[35%]' : variant === 'meta' ? 'w-[45%]' : '';
  const rightRatio =
    variant === 'rank' ? 'w-[65%]' : variant === 'meta' ? 'w-[55%]' : '';

  const isWarning = variant === 'warning';
  const leftBg = isWarning ? 'bg-transparent' : '';
  const leftStyle = isWarning ? undefined : { backgroundColor: leftColor };
  const shellClass = isWarning
    ? 'border-amber-400/80 bg-amber-50 dark:bg-amber-950/30'
    : 'border-edge bg-surface-muted';

  return (
    <div
      className={`flex w-full overflow-hidden rounded-lg border text-[11px] font-semibold leading-none ${shellClass} ${className}`}
      title={title}
    >
      <span
        className={`flex min-w-0 items-center justify-center px-1.5 py-1.5 ${
          useMinimalGrade ? 'flex-1' : `shrink-0 ${leftRatio}`
        } ${
          isWarning ? 'text-amber-800 dark:text-amber-200' : leftTextClass
        } ${leftBg}`}
        style={leftStyle}
      >
        <span className="truncate">{left}</span>
      </span>
      <span
        className={`flex items-center justify-center border-l border-edge/60 bg-surface py-1.5 text-ink ${
          useMinimalGrade
            ? 'w-[2rem] shrink-0 px-0.5 tabular-nums'
            : `min-w-0 px-1.5 ${rightRatio}`
        } ${isWarning ? 'bg-transparent text-amber-900 dark:text-amber-100' : ''}`}
      >
        <span className="truncate">{right}</span>
      </span>
    </div>
  );
}
